export default __webpack_public_path__ + "static/media/overwatch_banner_highlight.e8da8fdf.png";